<template>
  <v-container class="pa-0">
    <v-card
      ripple
      :to="link"
    >
      <v-card-text class="text-truncate">
        <!-- ICON -->
        <v-icon class="mr-2">mdi-plus</v-icon>
        <!-- TEXT + FIX OFFSET -->
        <span class="body-2 icon-text-offset">
          <slot />
        </span>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: "/",
    },
  },
  methods: {
    //
  },
};
</script>

<style></style>
